import { Selectable } from '@app/shared/models/selectable.interface';

export enum TagType {
  STANDARD = 'STANDARD',
  TENANT = 'TENANT',
  TENANT_MADE = 'TENANT_MADE',
  CHANNEL_LINK_GROUP = 'CHANNEL_LINK_GROUP',
  ROOM = 'ROOM',
  LIGHTING_PROFILE = 'LIGHTING_PROFILE'
}

export interface SelectableWithTags extends Selectable {
  tags?: Tag[];
}

export interface DisplayTags {
  displayTags: Tag[];
  tags: Tag[];
}

export interface Tag {
  buildingId?: number;
  name?: string;
  color?: string;
  id?: number;
  isActive: boolean;
  tagType?: TagType;
  isAvailable?: boolean;
  colorValue?: number;
}

export interface FloorplanTag extends Tag {
  isDirty: boolean;
  showEditForm?: boolean;
  checked: CheckboxState;
}

export function tagToFloorplanTag(other: Tag): FloorplanTag {
  return { ...other, isDirty: false, showEditForm: false, checked: CheckboxState.UNCHECKED, isActive: false };
}

export function tagsToFloorplanTags(other: Tag[]): FloorplanTag[] {
  const tagList: FloorplanTag[] = [];
  other.forEach((tag: Tag) => {
    tagList.push(tagToFloorplanTag(tag));
  })
  return tagList;
}

export enum CheckboxState {
  CHECKED = 'CHECKED',
  UNCHECKED = 'UNCHECKED',
  MIXED = 'MIXED'
}
